module.exports = "/assets/festival-banners/listing-banner-bw-mobile.png?9OAU2jr";